<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="SP"> </p>
<p class="EPI"><span aria-label="9" id="pg_9" role="doc-pagebreak">The laws of politics:</span></p>
<p class="EP">1. Get elected.</p>
<p class="EP">2. Get re-elected.</p>
<p class="EPL">3. Don’t get mad, get even.</p>
</blockquote>
<p class="EPS"><i>Senator Everett Dirksen (R. Illinois)</i></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?1656175b